import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BlackText from 'modules/emergencies/components/ui/texts/BlackText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled from 'styled-components';

const CustomBlackText = styled(BlackText)`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CustomRegularText = styled(RegularText)`
  font-weight: 700;
`;

export const ShipperColumn = ({ ticket }) => {
  const companyNameUppercase = ticket.shipper_data.company_name.toUpperCase();
  return (
    <BodyColumn
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.SHIPPER}
      columnBorderLeftColor={'white'}
      columnBorderLeftSize={'2px'}
    >
      <CustomBlackText>{companyNameUppercase}</CustomBlackText>
      <CustomRegularText>
        REF. {ticket.order_data.complementary_info.customer_internal_reference}
      </CustomRegularText>
    </BodyColumn>
  );
};
